export default __webpack_public_path__ + "static/media/tech-cloud-bg-3.9f948619.jpg";